











import { PageMode } from '@/main/utils/pageMode';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { EventBus } from '@/main/eventBus';

import { store } from '../store/edit';
import { ProvozovnaServisniPersonal } from '../servisniPersonal';
import { TAB_NAMES } from '../constants';

export default PageModeMixin.extend({
	name: TAB_NAMES.SERVISNI_PERSONAL,
	props: {
		storeUri: { type: String, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		objectName() {
			return TAB_NAMES.SERVISNI_PERSONAL;
		},
	},
	/** Emits the 'Mode' event. */
	updated() {
		EventBus.$emit('Mode', this.pageMode);
	},
	/** Emits the 'Mode' event. */
	mounted() {
		EventBus.$emit('Mode', this.pageMode);
		this.refreshTable();
	},
	methods: {
		...mapActionsDvm(store.actions),
		createClick() {
			openEdit(ProvozovnaServisniPersonal.name, PageMode.CREATE, {
				filter: {
					ProvozovnaId: this.ProvozovnaId,
				},
			});
		},
		async updateTable() {
			await this.getProvozovnaTableSchemaAndRows(TAB_NAMES.SERVISNI_PERSONAL);
		},
		refreshTable() {
			const table = this.$refs.table as any;
			table && table.refreshLayout();
		},
	},
});
